import { ReferralSourceEnum } from "@ecologi/shared";

export const locationCodeLabelMapper = {
  US: "Zip code",
  default: "Post code",
} as const;

export const referralSourceOptions = [
  {
    value: ReferralSourceEnum.UNKNOWN,
    label: "-- Please choose an option --",
  },
  {
    value: ReferralSourceEnum.SEARCH_ENGINE,
    label: "Search engine",
  },
  {
    value: ReferralSourceEnum.SOCIAL_MEDIA,
    label: "A social media post",
  },
  {
    value: ReferralSourceEnum.PRESS_ARTICLE,
    label: "Press article",
  },
  {
    value: ReferralSourceEnum.FRIEND,
    label: "A friend told me",
  },
  {
    value: ReferralSourceEnum.ADVERT,
    label: "I saw an advert",
  },
  {
    value: ReferralSourceEnum.TV,
    label: "TV",
  },
  {
    value: ReferralSourceEnum.OTHER,
    label: "Other",
  },
];
